import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth_service.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatButton, MatProgressBar]
})
export class LoginComponent implements OnInit {

    loginForm = new UntypedFormGroup({
      emailAddress: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl('', Validators.required),
    });

    loading = false;
    submitted = false;
    isLoginFailed = false;
    errorMessage = '';
    return = '';

    constructor(
        private router: Router,
        private formBuilder: UntypedFormBuilder,
        private tokenStorageService: TokenStorageService,
        private loginService: AuthService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => this.return = params.return || '/home');
    }

    get formControls(): { [p: string]: AbstractControl } {
        return this.loginForm.controls;
    }

    onSubmit(): void {
        this.loading = true;

        const username = this.formControls.emailAddress.value;
        const password = this.formControls.password.value;

        this.loginService.post([], { username, password }).subscribe(
            user => {
                this.loading = false;
                this.isLoginFailed = false;
                this.tokenStorageService.saveToken(user.token);
                this.tokenStorageService.saveUser(user);
                this.router.navigate([this.return]);
            },
            (error) => {
                this.loading = false;
                this.isLoginFailed = true;
                this.errorMessage = error;
            }
        );
    }
}
